import {Injectable} from "@angular/core";
import {MoovementApiClient} from "src/app/infrastructure/moovement-api/web-api/moovement.api-client";
import {Observable, of} from "rxjs";
import {Samples} from "src/app/infrastructure/moovement-api/models/samples";
import NfcLocationSampleMetadata = Samples.NfcLocationSampleMetadata;

// TODO remove mock data once the NFC location metadata visuals have been verified
const MOCK_NFC_LOCATION_METADATA: NfcLocationSampleMetadata[] = [
  {
    id: 'mock-1',
    userId: 'user-1',
    scannedAt: new Date('2026-09-28T08:15:00Z'),
    postedAt: new Date('2026-09-28T08:16:00Z'),
    scanningDevice: 'Handheld Reader A',
    failedScan: false,
    sampleCount: 1,
    discrepancyReason: '',
    samples: [
      {
        id: 'sample-1',
        deviceId: 'device-1',
        instant: '2026-09-28T08:15:00Z',
        capability: 'NFC_GPS_FIX',
        value: {
          position: {coords: [174.7633, -36.8485], srid: 4326},
          hdop: 1.2,
          fixQuality: 4,
          timeToFirstFix: 3,
          messageCounter: 1
        }
      }
    ]
  },
  {
    id: 'mock-2',
    userId: 'user-1',
    scannedAt: new Date('2026-09-29T11:42:00Z'),
    postedAt: new Date('2026-09-29T11:43:00Z'),
    scanningDevice: 'Handheld Reader B',
    failedScan: true,
    sampleCount: 0,
    discrepancyReason: 'Signal lost mid-scan',
    samples: []
  },
  {
    id: 'mock-3',
    userId: 'user-1',
    scannedAt: new Date('2026-10-01T06:05:00Z'),
    postedAt: new Date('2026-10-01T06:06:00Z'),
    scanningDevice: 'Handheld Reader A',
    failedScan: false,
    sampleCount: 1,
    discrepancyReason: '',
    samples: [
      {
        id: 'sample-2',
        deviceId: 'device-1',
        instant: '2026-10-01T06:05:00Z',
        capability: 'NFC_GPS_FIX',
        value: {
          position: {coords: [174.7645, -36.8502], srid: 4326},
          hdop: 0.9,
          fixQuality: 5,
          timeToFirstFix: 2,
          messageCounter: 2
        }
      }
    ]
  }
];

@Injectable({
  providedIn: 'root'
})
export class NfcLocationMetadataApiClient extends MoovementApiClient {

  getMetadata<T>(): Observable<NfcLocationSampleMetadata[]> {
    // TODO restore the real HTTP call once mock data is no longer needed
    // return of(MOCK_NFC_LOCATION_METADATA);
    return this.httpClient.get<NfcLocationSampleMetadata[]>(`${this.baseUrl}/api/nfc/all`)
  }
}
